<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Detalhes da Atividade") }}</h1>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div id="boxPrint" class="row">
      <div class="col-md-12">
        <print-content>

          <div v-for="atividade in atividades" :key="atividade.id">

            <table class="table b-table b-table-stacked-xs table-bordered table-sm bg-white">

              <tbody>
                <tr>
                  <td>
                    ID: <strong>{{ atividade.id }}</strong>
                  </td>
                  <td>
                    PROTOCOLO: <strong>{{ atividade.protocolo }}</strong>
                  </td>
                  <td>
                    CADASTRADO:
                    <strong>{{ atividade.created_at }}</strong>
                  </td>
                  <td>
                    ATUALIZADO:
                    <strong>{{ atividade.updated_at }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    TÉCNICO RESPONSÁVEL:
                    <strong>{{ atividade.responsavel && atividade.responsavel.tecnico ? atividade.responsavel.tecnico.nome : '' }}</strong>
                    <span class="badge badge-light">{{ atividade.responsavel?.tecnico?.profissao ?? "Não informado" }}</span>
                  </td>
                  <td colspan="2">
                    UNIDADE:
                    <strong>{{ atividade.unidade ? atividade.unidade.nome : '' }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    TÉCNICO AUTOR:
                    <b>{{ atividade.autor }}</b>
                  </td>
                </tr>
                <tr v-if="atividade.atividadesable_type != 'Modules\\Scfv\\Entities\\ScfvGrupo'">
                  <td colspan="4">
                    TÍTULO:
                    <strong>{{ atividade.titulo }}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    TIPO:
                    <strong>{{ atividade.tipo }}</strong>
                  </td>
                  <td colspan="2">
                    STATUS:
                    <strong v-html="atividade.status_nome"></strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    DATA:
                    <strong>{{ atividade.data | formatDate() }}</strong>
                  </td>
                  <td>
                    HORA:
                    <strong>{{ atividade.hora_print }}</strong>
                  </td>
                  <td>
                    DURAÇÃO:
                    <strong>{{ atividade.duracao }}</strong>
                  </td>
                </tr>
                <tr v-if="atividade.link_sala_reuniao && atividade.link_sala_reuniao !== ''">
                  <td colspan="4">
                    LINK DA SALA VIRTUAL: {{ atividade.link_sala_reuniao }}
                  </td>
                </tr>
                <tr v-if="atividade.atividadesable_type != 'Modules\\Scfv\\Entities\\ScfvGrupo'">
                  <td colspan="4">
                    OBSERVAÇÃO:
                    <div v-html="atividade.conteudo"></div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="p-3">
                    <p class="small text-muted">
                      Técnicos, Usuários ou Usuários SCFV participantes desta
                      Atividade
                    </p>
                    
                    <!-- EQUIPE - PARTICIPANTES (Quando há participantes_presentes) -->
                    <table
                      class="table b-table b-table-stacked-xs table-sm bg-white"
                      v-if="atividade.participantes_presentes && atividade.participantes_presentes.length > 0"
                    >
                      <thead>
                        <tr>
                          <th colspan="3" class="text-center">EQUIPE - PARTICIPANTES:</th>
                        </tr>
                        <tr>
                          <th></th>
                          <th>Nome</th>
                          <th style="width: 255px; min-width: 255px">
                            Assinatura
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(participante, index) in atividade.participantes_array"
                          :key="'equipe-' + (participante.id || index)"
                        >
                          <td width="27px">
                            <span v-if="atividade.participantes_presentes.includes(participante.id)">
                              <i class="fas fa-check"></i>
                            </span>
                            <span v-else>
                              <i class="fas fa-times"></i>
                            </span>
                          </td>
                          <td>
                            <b>{{ participante.nome }}</b>
                          </td>
                          <td width="255px" style="width: 255px; min-width: 255px"></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- TÉCNICOS PARTICIPANTES (Fallback quando não há participantes_presentes) -->
                    <table
                      class="table b-table b-table-stacked-xs table-sm bg-white"
                      v-else-if="participantesValidos(atividade).length > 0"
                    >
                      <thead>
                        <tr>
                          <th colspan="3" class="text-center">
                            <span
                              v-if="
                                atividade.atividadesable_type !=
                                'Modules\\Scfv\\Entities\\ScfvGrupo'
                              "
                              >TÉCNICOS</span
                            >
                            PARTICIPANTES:
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th>Nome</th>
                          <th style="width: 255px; min-width: 255px">
                            Assinatura
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(participante, index) in participantesValidos(atividade)"
                          :key="'tecnico-' + (participante.id || index)"
                        >
                          <td width="27px"></td>
                          <td>{{ participante.nome }}</td>
                          <td width="255px" style="width: 255px; min-width: 255px"></td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Usuários do Sistema Inscritos -->
                    <b-table
                      :fields="[
                        { key: 'presenca', label: '' },
                        { key: 'atividade', label: $t('Nome') },
                        { key: 'assinatura', label: 'Assinatura', thStyle: { width: '255px', minWidth: '255px' } }
                      ]"
                      :items="atividade.lista_inscritos"
                      :responsive="true"
                      hover
                      show-empty
                      small
                      outlined
                      stacked="md"
                      table-class="mb-3"
                      v-if="atividade.lista_inscritos && atividade.lista_inscritos.length > 0"
                    >
                      <template #thead-top="data">
                        <b-tr>
                          <b-th colspan="3" class="text-center">Usuários do Sistema Inscritos na Atividade</b-th>
                        </b-tr>
                      </template>
                      <template v-slot:cell(presenca)="data">
                        <span v-if="data.value"><i class="fas fa-check"></i></span>
                        <span v-else><i class="fas fa-times"></i></span>
                      </template>
                      <template v-slot:cell(atividade)="data">
                        <strong v-if="data.item.usuario">{{ data.item.usuario.nome_completo }}</strong>
                        <b v-if="data.item.usuario && data.item.usuario.data_nascimento">
                          {{ data.item.usuario.data_nascimento | calcIdade }} ano(s)
                        </b>
                      </template>
                      <template v-slot:empty="scope">
                        <div class="text-center my-5">
                          <img :alt="$t('No results')" class="mb-5" src="/img/icons/robot.svg" style="max-height: 165px" />
                          <h3 class="bold">{{ $t("No records found") }}</h3>
                        </div>
                      </template>
                    </b-table>

                    <!-- OUTROS PARTICIPANTES -->
                    <table
                      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
                      v-if="atividade.outros_participantes && atividade.outros_participantes.length > 0"
                    >
                      <thead>
                        <tr>
                          <th colspan="3" class="text-center">OUTROS PARTICIPANTES:</th>
                        </tr>
                        <tr>
                          <th></th>
                          <th>Nome</th>
                          <th style="width: 255px; min-width: 255px">Assinatura</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(nome, index) in atividade.outros_participantes" :key="'outro-' + index">
                          <td width="27px"></td>
                          <td><b>{{ nome }}</b></td>
                          <td width="255px" style="width: 255px; min-width: 255px"></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    USUÁRIOS SEM PRONTUÁRIO:
                    <b>{{ atividade.qtde_sem_printuario }}</b>
                  </td>
                </tr>

              </tbody>
            </table>

            <!-- Lógica SCFV -->
            <table class="table b-table b-table-stacked-xs table-bordered table-sm bg-white">
              <tbody>
                <tr><td>TEMA:<br /><span v-html="atividade.tema"></span></td></tr>
                <tr><td>OBJETIVO ESPECÍFICO:<br /><span>{{ atividade.objetivo_especifico }}</span></td></tr>
                <tr><td>DINÂMICA/SINTESE DE DESENVOLVIMENTO:<br /><span>{{ atividade.dinamica }}</span></td></tr>
                <tr><td>MATERIAIS A SEREM UTILIZADOS:<br /><span>{{ atividade.materiais_utilizados }}</span></td></tr>
              </tbody>
            </table>

            <print-footer
              v-if="atividade.responsavel && atividade.responsavel.tecnico && atividade.responsavel.tecnico.assinatura_digital"
              :tecnico="atividade.responsavel.tecnico"
              class="mt-0"
              :assinatura="atividade.responsavel.tecnico.assinatura_digital"
              :wpp="wpp"
              :email="email"
            />
            <span
              class="mr-2"
              v-for="(tecnico, index) in atividade.participantes_array"
              :key="'assinatura-' + index"
              v-if="outrasAssinaturas"
            >
              <print-footer
                v-if="tecnico && tecnico.assinatura_digital"
                :tecnico="tecnico"
                class="mt-0"
                :assinatura="tecnico.assinatura_digital"
              />
            </span>

            <div class="row">
              <div class="col-md-12">
                <modulo-comentario module="Atividade" :id="atividade.id" :showCommentForm="false"/>
              </div>
            </div>

            <div class="row pt-4 px-0 d-flex justify-content-end no-print mb-5">
              <div class="col-auto px-2 text-right">
                <b-button
                  :title="$t('Editar')"
                  :to="'/dashboard/atividades/edit/' + atividade.id"
                  type="button"
                  v-b-tooltip.hover
                  variant="success"
                  v-if="atividade.user_id == $store.state.user.id && atividade.atividadesable_type != 'Modules\\Scfv\\Entities\\ScfvGrupo'"
                >
                  <i class="mdi mdi-square-edit-outline" />
                </b-button>
              </div>
            </div>

            <hr class="my-5 no-print" />

          </div>

        </print-content>

        <!-- Paginação -->
        <div class="row no-print mt-3" v-if="totalRows > perPage">
          <div class="col-12 d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="boxPrint"
              align="center"
              @input="getItem"
            ></b-pagination>
          </div>
        </div>

        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <a class="btn btn-default" @click="$router.go(-1)">
              <i class="mdi mdi-arrow-left" />
            </a>
            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>
            <form-toggle grid="12" mt="0" v-model="email" label="Email" />
            <form-toggle grid="12" mt="0" v-model="wpp" label="Telefone/WhatsApp" />
            <form-toggle grid="12" mt="0" v-model="outrasAssinaturas" label="Assinatura Técnico (a) Participante" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      atividades: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      listapresenca: false,
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      outrasAssinaturas: false,
      wpp: true,
      email: true,
      comentarios: null,
      module: "Atividade",
    };
  },
  mounted() {
    this.getItem();
    this.getComentarios();
  },
  methods: {
    participantesValidos(atividade) {
      return (atividade.participantes_array || []).filter(p => p && typeof p === 'object');
    },
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/atividades/${this.$route.params.id}/Relatorio`, {
          params: {
            page: this.currentPage,
            perPage: this.perPage
          }
        })
        .then((response) => {
          this.atividades = response.data.data || [];
          this.totalRows = response.data.pagination ? response.data.pagination.total : this.atividades.length;
          this.listapresenca = this.atividades.some(a => a.status == 21);
          this.loading = false;
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          console.error("Erro ao buscar atividades:", error);
          this.$router.push("/dashboard/atividades/");
        });
    },
    getComentarios() {
      var model = this.model || this.module;
      axios
        .get(`api/dashboard/get/comentarios`, {
            params: {
                id: this.$route.params.id,
                module: this.module,
                model: model,
            }
        })
        .then((response) => {
            this.comentarios = response.data.data;
        })
        .finally(() => {
            this.loadingComentarios = false;
        });
    },
    print() {
      window.print();
    }
  },
};
</script>

<style scoped>


@media print {

  @page {
    margin: 10mm;
  }

  body {
    margin: 0;
    padding: 0;
  }

  body * {
    visibility: hidden;
  }

  #boxPrint, #boxPrint * {
    visibility: visible;
  }

  #boxPrint {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }

  table {
    width: 100%;
    page-break-inside: avoid;
  }

}
</style>
